import React from "react";
import styles from "./SurveyResultCard.module.css";
import {SurveyQuestion, SurveyResponseUi, SurveyTrigger} from "../../../../../../../api/generated";
import {formatDateTime} from "../../../../../../../utils/dateTimeUtil";

interface SurveyResultCardProps {
    survey: SurveyResponseUi
}

const QUESTION_LABELS: Record<SurveyQuestion, string> = {
    [SurveyQuestion.Helpfulness]: "Helpfulness",
    [SurveyQuestion.Accuracy]: "Accuracy",
    [SurveyQuestion.Clarity]: "Clarity",
};

const QUESTION_ORDER: SurveyQuestion[] = [SurveyQuestion.Helpfulness, SurveyQuestion.Accuracy, SurveyQuestion.Clarity];

const TRIGGER_LABELS: Record<SurveyTrigger, string> = {
    [SurveyTrigger.EndChat]: "after End chat",
    [SurveyTrigger.MessageCount]: "after the message count",
    [SurveyTrigger.Booking]: "after a booking",
};

export const SurveyResultCard: React.FC<SurveyResultCardProps> = ({survey}) => {
    const {date, time} = formatDateTime(survey.createdAt);
    const answers = [...survey.answers].sort((left, right) =>
        QUESTION_ORDER.indexOf(left.question) - QUESTION_ORDER.indexOf(right.question));

    return <div className={styles.card}>
        <div className={styles.header}>
            <span className={styles.title}>Survey</span>
            <span className={styles.meta}>{TRIGGER_LABELS[survey.trigger]} · {date} {time}</span>
        </div>
        {answers.map(answer => <div key={answer.question} className={styles.answer}>
            <div className={styles.row}>
                <span>{QUESTION_LABELS[answer.question]}</span>
                <span className={styles.rating}>{answer.rating} / 5</span>
            </div>
            {answer.comment && <div className={styles.comment}>“{answer.comment}”</div>}
        </div>)}
    </div>
}
